import { MouseEventHandler, useState } from "react";
import { FONT } from "../../value/staticValues";

import { ReactComponent as PrevStepImg } from "../../img/ico-step-arrow.svg";
import { ReactComponent as PrevStepActiveImg } from "../../img/ico-step-arrow-active.svg";
import { StyleSheet } from "react-native";

interface CustomPrevBtnProps {
    size?: { width?: number; height?: number };
    fontsize?: number;
    text: String;
    disabled?: boolean;
    onPress: MouseEventHandler;
}

export function CustomPrevBtn(props:CustomPrevBtnProps) {
    const [mouseState, setMouseState] = useState(false);

    return (
        <div
            style={{
                width: props.size?.width || 90, minWidth: 90,
                height: props.size?.height || 36, minHeight: 36,
                display: "flex", justifyContent: "center", alignItems: "center",
                borderRadius: 10,
                backgroundColor: "#f5f5f5",
                fontFamily: FONT.MEDIUM,
                fontSize: props.fontsize? props.fontsize : 12,
                color: "#262626",
                cursor: props.disabled ? "initial" : "pointer",
            }}
            onMouseOut={() => {
                setMouseState(false);
            }}
            onMouseOver={() => {
                setMouseState(true);
            }}
            onClick={(e)=>{if(!props.disabled) props.onPress(e);}}
        >
            {mouseState? <PrevStepActiveImg style={style.arrowImg}/> : <PrevStepImg style={style.arrowImg}/>}
            {props.text}
        </div>
    )
}

const style = StyleSheet.create({
    arrowImg: {
        width: 24, height: 24,
        marginRight: -2
    }
})